import { useState } from 'react';
import './LoginForm.css';
import './Global.css';

function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const response = await fetch("https://api2.gloomium.com/private/register.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Response from server:", data);
      // You can handle success or errors here (e.g., show messages)
    } catch (error) {
      console.error("Error sending data:", error);
      // Handle fetch or network errors here
    }
  }

  return (
    <form>
      <label>Email Address</label>
      <input
        className="s-margin-top s-margin-bottom2"
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />

      <label>Password</label>
      <input
        className="s-margin-top s-margin-bottom2"
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />

      <button type="button" onClick={handleSubmit}>Login</button>

      <p>Don't have an account? <a href="/register">Register Now</a></p>
    </form>
  );
}

export default LoginForm;
